import React from 'react';
import { isSaudiBrand } from '../utils/isSaudiBrand';
import QawaemTableToolbarColumnPicker from './QawaemTableToolbarColumnPicker';
import { mergeStickyActionsClass } from './QawaemTableStickyActions';

/**
 * Table header cell: actions label + optional column-picker icon (left of label in RTL).
 * Matches المنتجات pattern — icon beside الإجراءات, not in the title toolbar.
 */
export default function QawaemTableHeaderActionsCell({
  label,
  columns,
  onToggle,
  visibleCount,
  totalCount,
  thClassName = 'px-6 py-3 text-center text-white font-semibold text-sm whitespace-nowrap align-middle',
  showPicker = isSaudiBrand(),
  sticky = true,
  ...thRest
}) {
  const cols = Array.isArray(columns) ? columns : null;
  const visible = visibleCount ?? cols?.filter((c) => c.checked !== false).length;
  const total = totalCount ?? cols?.length ?? 0;

  const picker = showPicker && cols?.length ? (
    <QawaemTableToolbarColumnPicker
      variant="icon"
      align="end"
      columns={cols}
      onToggle={onToggle || (() => {})}
      visibleCount={visible}
      totalCount={total}
    />
  ) : null;

  const resolvedThClass = sticky ? mergeStickyActionsClass(thClassName) : thClassName;

  if (!picker) {
    return <th className={resolvedThClass} {...thRest}>{label}</th>;
  }

  return (
    <th className={resolvedThClass} {...thRest}>
      <div className="flex items-center justify-center gap-2 min-h-[1.75rem]">
        <span>{label}</span>
        {picker}
      </div>
    </th>
  );
}
